export default {
    "north": {"x": 0, "y": -1},
    "south": {"x": 0, "y": +1},
    "east": {"x": +1, "y": 0},
    "west": {"x": -1, "y": 0},
    "southeast": {"x": +1, "y": +1},
    "northeast": {"x": +1, "y": -1},
    "southwest": {"x": -1, "y": +1},
    "northwest": {"x": -1, "y": -1},
}
